import { LoadingOverlay } from "cayo.ui";

import { CancellationPanel } from "../CancellationPanel";
import { BlankSearchWrapper } from "./BlankSearchWrapper";

interface BlankSearchResultProps {
  isLoading: boolean | null;
  hasConditions: boolean;
  noItemsText?: string;
  onClear: () => void;
  onAbort?: () => void;
}

export const BlankSearchResult = ({
  isLoading,
  hasConditions,
  onAbort,
  onClear,
  noItemsText,
}: BlankSearchResultProps) => {
  return (
    <BlankSearchWrapper
      isLoading={isLoading}
      hasConditions={hasConditions}
      clearQuery={onClear}
      noItemsText={noItemsText}
    >
      {onAbort ? <CancellationPanel onAbort={onAbort} /> : <LoadingOverlay />}
    </BlankSearchWrapper>
  );
};
